module.exports = __webpack_public_path__ + "img/roadpursuit-grey-logo.155d0476.svg";